import { styled } from "@mui/material/styles";
import { FunctionComponent, useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

import { colorGrayLight } from "../../styles/theme";
import { Box, InputBase } from "@mui/material";
import { PossibleLabelValue } from "../../context/ConfigContext/types";
import AcceptIcon from "../Icons/AcceptIcon";
import RejectIcon from "../Icons/RejectIcon";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Pill = styled("div")(({ theme }) => ({
	display: "inline-flex",
	alignItems: "center",
	justifyContent: "space-between",
	backgroundColor: colorGrayLight,
	borderRadius: 24,
	padding: "1px 1px 1px 12px",
	width: "95%",
	position: "relative",
}));

const StyledInput = styled(InputBase)(() => ({
	"& .MuiInputBase-input": {
		padding: "4px 0",
		minWidth: "202px",
		fontSize: "12px",
		backgroundColor: "white",
		borderRadius: 24,
	},
	"&:before, &:after": {
		border: 0,
	},
}));

const StyledSelect = styled(Select)(({ theme }) => ({
	".MuiSelect-select": {
		paddingLeft: "12px",
		minWidth: 160,
		fontSize: "12px",
		color: "black",
		outline: "none",
		border: "none",
	},
	"& .MuiSelect-icon": {
		color: theme.palette.grey[400],
		right: 0,
	},
	".MuiSelect-select:focus": {
		borderRadius: 24,
	},
}));

const StyledExpandMoreIcon = styled(ExpandMoreIcon)({
	fontSize: "20px",
	marginRight: "5px",
});

interface Props {
	labelName: string;
	labelValue: string;
	options: PossibleLabelValue[];
	predictionValue: string;
	onChange?: (value: string) => void;
}

const CategoryLabelDropdown: FunctionComponent<Props> = ({
	labelName,
	labelValue,
	predictionValue,
	options,
	onChange,
}) => {
	const [menuOpen, setMenuOpen] = useState(false);
	const hasUserLabel = Boolean(labelValue);
	const displayedValue = hasUserLabel ? labelValue : predictionValue;
	const optionsWithoutSelectedValue = options.filter(
		(o) => o.value !== displayedValue
	);

	return (
		<Pill>
			<Typography sx={{ fontSize: "12px" }}>{labelName}</Typography>
			<StyledSelect
				open={menuOpen}
				onOpen={() => setMenuOpen(true)}
				onClose={() => setMenuOpen(false)}
				onChange={(e) => onChange?.(e.target.value as string)}
				value={displayedValue}
				IconComponent={hasUserLabel ? StyledExpandMoreIcon : () => null}
				native={false}
				input={<StyledInput />}
				renderValue={(val) => val as string}
				MenuProps={{
					PaperProps: {
						sx: {
							mt: 0.5,
							bgcolor: colorGrayLight,
							borderRadius: "12px",
							paddingBlock: "5px",
						},
					},
					MenuListProps: {
						disablePadding: true,
					},
				}}
			>
				{optionsWithoutSelectedValue?.map((option) => (
					<MenuItem
						sx={{ fontSize: "12px", paddingInline: "12px" }}
						value={option.value}
					>
						{option.value}
					</MenuItem>
				))}
			</StyledSelect>
			{!hasUserLabel && (
				<Box
					sx={{
						position: "absolute",
						display: "flex",
						right: 10,
						top: 10,
						gap: "4px",
					}}
				>
					<AcceptIcon
						onClick={() => onChange(predictionValue)}
						sx={{
							fontSize: 14,
							cursor: "pointer",
							fill: "#4EBC78",
						}}
					/>
					<RejectIcon
						onClick={() => setMenuOpen(true)}
						sx={{ fontSize: 14, cursor: "pointer" }}
					/>
				</Box>
			)}
		</Pill>
	);
};

export default CategoryLabelDropdown;
